import type { FrameType } from "@/api/spaces";
import { translate } from "@/i18n";
import { framesSharedMessages } from "@/i18n/messages/frames-shared";
import type en from "@/i18n/messages/frames-shared/en";

const FRAME_TYPE_KEY = {
  markdown: "frameTypeMarkdown",
  html: "frameTypeHtml",
  question: "frameTypeQuestion",
  code: "frameTypeCode",
  search: "frameTypeSearch",
  workflow: "frameTypeWorkflow",
  image: "frameTypeImage",
  email: "frameTypeEmail",
  newsletter: "frameTypeNewsletter",
  connection: "frameTypeConnection",
  connection_prompt: "frameTypeConnectionPrompt",
  memory: "frameTypeMemory",
  note: "frameTypeNote",
  doc: "frameTypeDoc",
  conversation: "frameTypeConversation",
  linkedin: "frameTypeLinkedin",
  agent_list: "frameTypeAgentList",
  agent_settings: "frameTypeAgentSettings",
  taskboard: "frameTypeTaskboard",
  github: "frameTypeGithub",
  event: "frameTypeEvent",
  agenda: "frameTypeAgenda",
  flight: "frameTypeFlight",
  weather: "frameTypeWeather",
  chart: "frameTypeChart",
  dataset: "frameTypeDataset",
  preview_card: "frameTypePreviewCard",
  link_preview: "frameTypeLinkPreview",
  chat: "frameTypeChat",
  slack: "frameTypeSlack",
  todo: "frameTypeTodo",
  board: "frameTypeBoard",
  music: "frameTypeMusic",
  calendar: "frameTypeCalendar",
  file: "frameTypeFile",
  terminal: "frameTypeTerminal",
} as const satisfies Record<FrameType, keyof typeof en>;

/** A frame type's name in the app language; call it at render time. */
export function frameTypeLabel(frameType: string): string {
  const key = FRAME_TYPE_KEY[frameType as FrameType];
  if (key) return translate(framesSharedMessages, key);
  // A type this build has no name for still reads as words.
  const words = frameType.replace(/[_-]+/g, " ").trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
